
import { GameManager } from "../GameManager";
import { AudioManager } from "../AudioManager";
import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { GameTitle } from "./GameTitle";

export class PreloadScene extends Phaser.Scene {

    public static currentInstance: PreloadScene;

    private progressBar: Phaser.GameObjects.Graphics;
    private f: number;

    constructor() {

        super("PreloadScene");

        PreloadScene.currentInstance = this;
    }

    public preload(): void {

        this.f = 0;

        this.composeScene();

        this.loadAssets();
    }

    public create(): void {

        this.loadHowl();
    }

    public update(): void {

        this.f ++;

        if (this.f === 10) {
            const loadingLabel = this.add.text(5, GameConstants.GAME_HEIGHT - 15, "LOADING...", {fontFamily: "Supercell", fontSize: "40px", color: "#FFFFFF"});
            loadingLabel.setOrigin(0, 1);
            loadingLabel.scaleY = GameVars.scaleY;
            loadingLabel.setStroke("#000000", 8);
        }
    }
    
    private composeScene(): void {

        this.add.text(-100, -100, "abcdefg", { fontFamily: "Supercell", fontSize: 28, color: "#A6F834" });

        const backgroundContainer = this.add.container(0, 0);
        backgroundContainer.scaleY = GameVars.scaleY;

        let n = Math.round(GameConstants.GAME_HEIGHT / 128 / GameVars.scaleY) + 1;

        for (let i = 0; i < n; i ++) {
            const backgroundSlice = new Phaser.GameObjects.Image(this, 0, i * 128, "texture_atlas_0", "splash_bg");
            backgroundSlice.setOrigin(0, 0);
            backgroundContainer.add(backgroundSlice);
        }

        const gradient = this.add.image(0, 0, "texture_atlas_0", "blue_gradient");
        gradient.setOrigin(0);
        gradient.scaleX = GameConstants.GAME_WIDTH / 10;
        gradient.scaleY = 1.35 / GameVars.scaleY;

        const gameTitle = new GameTitle(this);
        gameTitle.x = GameConstants.GAME_WIDTH / 2 + 14;
        gameTitle.y = 160 * GameVars.scaleY;
        this.add.existing(gameTitle);

        this.progressBar = this.add.graphics();
        this.progressBar.fillStyle(0xFFFFFF);
        this.progressBar.fillRect(0, GameConstants.GAME_HEIGHT - 10, GameConstants.GAME_WIDTH, 10);
        this.progressBar.scaleX = 0;
    }

    private loadAssets(): void {

        this.load.atlas("texture_atlas_1", "assets/texture_atlas_1.png", "assets/texture_atlas_1.json");
        this.load.atlas("texture_atlas_2", "assets/texture_atlas_2.png", "assets/texture_atlas_2.json");
        this.load.atlas("texture_atlas_3", "assets/texture_atlas_3.png", "assets/texture_atlas_3.json");

        // EL TEXTO DEL JUEGO
        this.load.json("game-text", "assets/config/text.json");

        // fuentes
        this.load.bitmapFont("supercell-white", "assets/fonts/supercell-white.png", "assets/fonts/supercell-white.xml");
        this.load.bitmapFont("supercell-red", "assets/fonts/supercell-red.png", "assets/fonts/supercell-red.xml");

        this.load.json("sound", "assets/audio/sound.json");
        this.load.json("music", "assets/audio/music.json");

        this.load.on("progress", this.updateLoadedPercentage, this);
    }

    private updateLoadedPercentage(percentageLoaded: number): void {

        if (this.progressBar.scaleX < percentageLoaded) {
            this.progressBar.scaleX = percentageLoaded;
        }
    }

    private loadHowl(): void {

        let musicJson = this.cache.json.get("music");
        musicJson = JSON.parse(JSON.stringify(musicJson).replace("urls", "src"));

        AudioManager.music = new Howl(musicJson);
    
        AudioManager.music.on("load", function() {

            let soundJson = PreloadScene.currentInstance.cache.json.get("sound");
            soundJson = JSON.parse(JSON.stringify(soundJson).replace("urls", "src"));

            AudioManager.sound = new Howl(soundJson);

            AudioManager.sound.on("load", function() {
                GameManager.setCurrentScene(PreloadScene.currentInstance);
                PreloadScene.currentInstance.scene.setVisible(false);
                GameManager.onGameAssetsLoaded();
            });
        });
    }
}
